import React, { useEffect, useState } from "react";
import "./styles/RemoteControl.css";
import "./styles/RemoteSelector.css";
import axios from "axios";
import ExtraButtons from "./ExtraButtons";
import LIRCDhealth from "./LIRCDhealth";
import ButtonsSequence from "./ButtonsSequence";

function RemoteControl() {
  const harness_IP_address = "10.255.255.114";
  const [savedButtons, setSavedButtons] = useState({});
  const [remotes, setRemotes] = useState([]);
  const [selectedRemote, setSelectedRemote] = useState("");
  const [sendRemoteButton, setSendRemoteButton] = useState("");
  const [requestProcess, setRequestProcess] = useState({
    type: true,
    msg: "",
  });
  const [showLIRCDhealth, setShowLIRCDhealth] = useState(false);

  const CheckSavedButtons = async () => {
    try {
      const { data } = await axios.get(`/v1/send_ir/check-saved-remotes`);

      console.log(data.SavedButtons);

      setSavedButtons(data.SavedButtons);
      const remoteNames = Object.keys(data.SavedButtons).map((key) =>
        key.replace("_lirc", ""),
      );
      setRemotes(remoteNames);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    CheckSavedButtons();
  }, []);

  const handleSelect = (event) => {
    setSelectedRemote(event.target.value);
  };

  async function sendCommand(command) {
    let foundMatch = false;
    let url = `v1/send_ir/${selectedRemote}/`;
    // Check if the selected remote exists in savedButtons
    const remoteKey = selectedRemote + "_lirc";
    if (!selectedRemote) {
      setRequestProcess({
        type: false,
        msg: `Please select remote first`,
      });
      return;
    }
    if (!savedButtons[remoteKey]) {
      console.log(`No remote found for key: ${remoteKey}`);
      setRequestProcess({
        type: false,
        msg: `No remote found for key: ${remoteKey}`,
      });
      return;
    }

    // Get the buttons for the selected remote
    const remoteButtons = savedButtons[remoteKey];

    // Find the key where the value matches the command
    Object.entries(remoteButtons).forEach(([key, value]) => {
      if (
        typeof value === "string" &&
        value.toLowerCase().includes(command.toLowerCase())
      ) {
        // console.log(`Matched key: ${key}, button value: ${value}`);
        if (!foundMatch) {
          url = url + value;
        }
        foundMatch = true;
      }
    });
    if (!foundMatch) {
      setRequestProcess({
        type: false,
        msg: "No button found for the button",
      });
      return;
    }

    const now = new Date();
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    const milliseconds = String(now.getMilliseconds()).padStart(3, "0");

    try {
      const { data } = await axios.get(`/${url}`);

      console.log(data);
      setRequestProcess({
        type: true,
        msg: `Success: Button ${command} sent at ${now.getHours()}:${minutes}:${seconds}.${milliseconds}.`,
      });
    } catch (error) {
      console.log(error);
      setRequestProcess({
        type: false,
        msg: `FAILED: Button ${command} sent at ${now.getHours()}:${minutes}:${seconds}.${milliseconds}.`,
      });
    }
  }
  function waitTimer(delay) {
    return new Promise((resolve) => setTimeout(resolve, delay));
  }
  // const extraScript = async () => {
  //     sendCommand("Menu");
  //     await waitTimer(150);
  //     sendCommand("ArrowLeft");
  //     await waitTimer(300);
  //     sendCommand("ArrowRight");
  //     await waitTimer(300);

  //     sendCommand("9");
  //     await waitTimer(300);

  //     sendCommand("3");
  //     await waitTimer(300);

  //     sendCommand("7");
  //     await waitTimer(300);

  //     sendCommand("1");
  //     await waitTimer(300);

  //     sendCommand("ArrowDown");
  //     sendCommand("ArrowDown");
  //     sendCommand("ArrowDown");
  //     sendCommand("ArrowDown");
  //     sendCommand("ArrowDown");
  //     sendCommand("ArrowDown");
  //     sendCommand("ArrowDown");
  //     sendCommand("ArrowDown");
  // };
  return (
    <section className="remote-display">
      <br />
      <br />
      <br />
      <br />

      <ButtonsSequence
        selectedRemote={selectedRemote}
        data={savedButtons}
        CallFunction={sendCommand}
      />

      {/* <button onClick={extraScript}>Extra script</button> */}
      <div className="remote-container">
        <p
          id="buttonPressed"
          className={`buttonPressed ${
            requestProcess.type ? "successReq" : "failedReq"
          }`}
        >
          {requestProcess.msg}
        </p>
        {/* Header Section */}
        <div className="remote-header">
          <button
            className="remote-button power-button"
            onClick={() => sendCommand("Power")}
          >
            Power
          </button>
        </div>

        {/* <!-- Numeric Buttons --> */}
        <div className="remote-numeric">
          <div className="remote-row">
            <button className="remote-button" onClick={() => sendCommand("1")}>
              1
            </button>
            <button className="remote-button" onClick={() => sendCommand("2")}>
              2
            </button>
            <button className="remote-button" onClick={() => sendCommand("3")}>
              3
            </button>
          </div>
          <div className="remote-row">
            <button className="remote-button" onClick={() => sendCommand("4")}>
              4
            </button>
            <button className="remote-button" onClick={() => sendCommand("5")}>
              5
            </button>
            <button className="remote-button" onClick={() => sendCommand("6")}>
              6
            </button>
          </div>
          <div className="remote-row">
            <button className="remote-button" onClick={() => sendCommand("7")}>
              7
            </button>
            <button className="remote-button" onClick={() => sendCommand("8")}>
              8
            </button>
            <button className="remote-button" onClick={() => sendCommand("9")}>
              9
            </button>
          </div>
          <div className="remote-row">
            <button
              className="remote-button wide-button"
              onClick={() => sendCommand("0")}
            >
              0
            </button>
          </div>
        </div>

        {/* Volume and Mute Buttons */}
        <div className="remote-controls">
          <div>
            <button
              className="remote-button"
              onClick={() => sendCommand("Vol+")}
            >
              Vol +
            </button>
            <button
              className="remote-button"
              onClick={() => sendCommand("Vol-")}
            >
              Vol -
            </button>
          </div>
          <button className="remote-button" onClick={() => sendCommand("Mute")}>
            Mute
          </button>
          <div>
            <button
              className="remote-button"
              onClick={() => sendCommand("Channel+")}
            >
              Chan +
            </button>
            <button
              className="remote-button"
              onClick={() => sendCommand("Channel-")}
            >
              Chan -
            </button>
          </div>
        </div>

        {/* Navigation Buttons */}
        <div className="remote-navigation">
          <button
            className="remote-button nav-button"
            onClick={() => sendCommand("ArrowUp")}
          >
            ▲
          </button>
          <div className="remote-row">
            <button
              className="remote-button nav-button"
              onClick={() => sendCommand("ArrowLeft")}
            >
              ◄
            </button>
            <button
              className="remote-button nav-button center-button"
              onClick={() => sendCommand("OK")}
            >
              OK
            </button>
            <button
              className="remote-button nav-button"
              onClick={() => sendCommand("ArrowRight")}
            >
              ►
            </button>
          </div>
          <button
            className="remote-button nav-button"
            onClick={() => sendCommand("ArrowDown")}
          >
            ▼
          </button>
        </div>

        {/* Other Buttons */}
        <div className="remote-actions">
          <button className="remote-button" onClick={() => sendCommand("Home")}>
            Home
          </button>
          <button className="remote-button" onClick={() => sendCommand("Menu")}>
            Menu
          </button>
          <button
            className="remote-button"
            onClick={() => sendCommand("Source")}
          >
            Source
          </button>
        </div>
        <div className="remote-actions">
          <button
            className="remote-button"
            onClick={() => sendCommand("Guide")}
          >
            Guide
          </button>
          <button className="remote-button" onClick={() => sendCommand("Back")}>
            Back
          </button>
          <button className="remote-button" onClick={() => sendCommand("Exit")}>
            EXIT
          </button>
        </div>

        {/* Media Buttons */}
        <div className="remote-media">
          <button className="remote-button" onClick={() => sendCommand("Play")}>
            ▶
          </button>
          <button
            className="remote-button"
            onClick={() => sendCommand("Pause")}
          >
            ⏸
          </button>
          <button
            className="remote-button"
            onClick={() => sendCommand("MEDIA_SeekForw")}
          >
            {" >> "}
          </button>
          <button
            className="remote-button"
            onClick={() => sendCommand("SeekBack")}
          >
            {" << "}
          </button>
        </div>
        <div className="remote-media">
          <button
            className="remote-button"
            onClick={() => sendCommand("Red")}
            style={{ backgroundColor: "red" }}
          >
            R
          </button>
          <button
            className="remote-button"
            onClick={() => sendCommand("Blue")}
            style={{ backgroundColor: "blue" }}
          >
            B
          </button>
          <button
            className="remote-button"
            onClick={() => sendCommand("Green")}
            style={{ backgroundColor: "green" }}
          >
            G
          </button>
          <button
            className="remote-button"
            onClick={() => sendCommand("Yellow")}
            style={{ backgroundColor: "yellow" }}
          >
            Y
          </button>
        </div>
      </div>
      <div className="selectRemoteControl">
        <div className="remote-selector-container">
          <h3 className="remote-selector-title">Select a Remote</h3>
          <select
            className="remote-selector-dropdown"
            value={selectedRemote}
            onChange={handleSelect}
          >
            <option value="" disabled>
              Choose a remote
            </option>
            {remotes.map((remote, index) => (
              <option
                key={index}
                value={remote}
                className="remote-selector-option"
              >
                {remote}
              </option>
            ))}
          </select>
          {selectedRemote && (
            <p className="remote-selector-selection">
              Selected Remote: {selectedRemote}
            </p>
          )}
        </div>
        <ExtraButtons
          selectedBrand={selectedRemote}
          data={savedButtons}
          harness_IP_address={harness_IP_address}
        />

        <p
          id="buttonPressed"
          className={`buttonPressed ${
            requestProcess.type ? "successReq" : "failedReq"
          }`}
        >
          {requestProcess.msg}
        </p>

        <div className="lircd-health-box">
          <div className="unique-switch-container">
            <label className="unique-switch">
              <input
                type="checkbox"
                checked={sendRemoteButton}
                onChange={() => setSendRemoteButton(!sendRemoteButton)}
              />
              <span className="unique-slider"></span>
            </label>
            <p> {sendRemoteButton ? "Hide" : "Show"} IR-Blaster Health</p>
          </div>
          {sendRemoteButton && (
            <LIRCDhealth harness_IP_address={harness_IP_address} />
          )}
        </div>
      </div>
    </section>
  );
}

export default RemoteControl;
